import React, { useCallback, useMemo } from "react";
import styles from "./TextField.module.scss";

const TextField = (props) => {
  const {
    className: classNameProp,
    formik,
    namespace,
    onChange: onChangeProp,
    value: valueProp,
    ...otherProps
  } = props;

  const className = useMemo(() => {
    if (classNameProp) {
      return ["form-control", styles.textfield, classNameProp].join(" ");
    }

    return ["form-control", styles.textfield].join(" ");
  }, [classNameProp]);

  const onChange = useCallback(
    (e) => {
      if (formik) {
        formik.setFieldValue(namespace, e.target.value);
      }

      if (onChangeProp) {
        onChangeProp(e);
      }
    },
    [formik, namespace, onChangeProp]
  );

  const value = useMemo(() => {
    if (valueProp) {
      return valueProp;
    }

    if (formik) {
      return formik.values[namespace];
    }
  }, [formik, namespace, valueProp]);

  return (
    <input
      {...otherProps}
      className={className}
      onChange={onChange}
      value={value}
    />
  );
};

export default TextField;
